export default class CloseLotDto {
    constructor(closeLotData) {
        this.closingReason = closeLotData?.closingReason ?? '';
        this.notCompliantReason = closeLotData?.notCompliantReason ?? '';
        this.comment = closeLotData?.comment ?? '';
    }
}